import { normalizeNumberInput } from "./normalizeNumberInput";

export const buildSearchQueryString = (filters) => {
  const urlSearchParams = new URLSearchParams();

  const appendArrayParams = (urlSearchParams, parameterName, values) => {
    const safeValues = Array.isArray(values) ? values : [];
    safeValues.forEach((value) => {
      if (value == null) return;
      const stringValue = String(value);
      if (stringValue === "") return;
      urlSearchParams.append(parameterName, stringValue);
    });
  };

  appendArrayParams(urlSearchParams, "keyword[]", filters?.keyword);
  appendArrayParams(urlSearchParams, "roles[]", filters?.roleIds);
  appendArrayParams(urlSearchParams, "prefecture_ids[]", filters?.prefectureIds);

  const priceFilter = filters?.priceFilter;
  const normalizedPrice = normalizeNumberInput(priceFilter?.value);

  if (String(normalizedPrice).trim() !== "") {
    urlSearchParams.set("price", normalizedPrice);
  }

  return urlSearchParams.toString();
};